import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=680c5564&scoped=true&"
import script from "./myTask.vue?vue&type=script&lang=js&"
export * from "./myTask.vue?vue&type=script&lang=js&"
import style0 from "./myTask.vue?vue&type=style&index=0&lang=css&"
import style1 from "./myTask.vue?vue&type=style&index=1&id=680c5564&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c5564",
  null
  
)

export default component.exports